<template>
  <div
    id="report-view"
    class="border rounded-lg w-full flex flex-col bg-white overflow-auto"
  >
    <div>
      <Header
        :printable="printable"
        :form="reportData.form"
        :customer-logo="customerLogo"
        :pdf-source="currentPDFSource"
        @downloadPdf="setDownloadPdf"
        @downloadExcel="setDownloadExcel"
        @printReport="setPrintReport"
      >
        <div slot="header">
          <h3 class="text-bold mb-4">
            {{ dateOptions[reportData.form.dataForm] }}
            {{ reportData.form.reportType.replace('Report', '') }} Report
          </h3>
        </div>
        <div class="w-full" slot="sub-header">
          <div
            class="w-full flex justify-start lg:flex-row lg:justify-start"
            v-for="(title, index) in reportHeader"
            :key="index"
          >
            <div class="mt-2 font-regular text-base font-bold w-1/2 lg:w-1/5">
              {{ title.name }}
            </div>
            <div class="mt-2 text-base w-1/2 lg:w-full">
              : {{ title.content }}
            </div>
          </div>
        </div>
      </Header>
      <div
        class="px-4 py-4 pb-2 w-full items-center justify-center bg-gray-200"
      >
        <!-- Dco Data section -->
        <DcoDataReport
          :report-header="reportHeader"
          :report-data="reportData"
          :period="dateOptions[reportData.form.dataForm]"
          @pdfSource="pdfSource"
          v-if="isDcoReport()"
        />
        <!-- Dco Data section -->

        <!-- Alarm Data section -->
        <AlarmReport
          :report-header="reportHeader"
          :report-data="reportData"
          :period="dateOptions[reportData.form.dataForm]"
          @pdfSource="pdfSource"
          v-else-if="isAlarmReport()"
        />
        <!-- Alarm Data section -->

        <!-- Groupped Report section -->
        <GrouppedReport
          :report-header="reportHeader"
          :report-data="reportData"
          :period="dateOptions[reportData.form.dataForm]"
          @pdfSource="pdfSource"
          v-else-if="isGrouppingSumReport()"
        />
        <!-- Groupped Report section -->

        <!-- Common Report section -->
        <CommonReport
          :report-header="reportHeader"
          :report-data="reportData"
          :period="dateOptions[reportData.form.dataForm]"
          @pdfSource="pdfSource"
          v-else
        />
        <!-- Common Report section -->
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Reports/Header'
import SummaryChart from '@/components/Reports/SummaryChart'
import reportContentMixin from '@/mixins/ReportContent'
import DcoDataReport from '@/components/Reports/DCODataReport'
import AlarmReport from '@/components/Reports/AlarmReport'
import CommonReport from '@/components/Reports/CommonReport'
import GrouppedReport from '@/components/Reports/GrouppedReport'

export default {
  mixins: [reportContentMixin],
  components: {
    Header,
    SummaryChart,
    DcoDataReport,
    AlarmReport,
    CommonReport,
    GrouppedReport
  },
  data() {
    return {
      grouppedAssets: [],
      assets: []
    }
  },
  methods: {}
}
</script>

<style>
#report-view .dx-datagrid-headers table tr.dx-header-row td {
  --bg-opacity: 1;
  background-color: #63b3ed !important;
  color: #fff !important;
}
</style>
